import { executeRequest, JFSRequest } from '@jfs/network'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, sitConfig } from './config'

const responseParser = (response: any) => {
  return response
}

const updateConfig = (entityId: string, configValues: any[], configurations: any[], tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath: APIEndPoints.configUpdate,
    method: 'POST',
    cache: false,
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: {
      entityId: entityId,
      configValues: configValues,
      configurations: configurations,
    },
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { updateConfig }
